import APIDOC from '@/common/serverApi';
import {get, post, postJSON, postParams, postFormData} from '@/common/request';

export default {
    namespaced: true, state: {}, mutations: {}, actions: {
        // 退出
        logout({commit}, payload) {
            commit('STARTREQUEST');
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.logout, payload)
                    .then((ret) => {
                        commit('ENDREQUEST');
                        resolve(ret);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST');
                        reject(err);
                    });
            });
        }, // 用户数据
        getStudentInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },

        // 上传报道材料（审核不通过后的重新上传也是这个）
        uploadStudentNewData({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.uploadStudentNewData, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //查询已上传的报道材料（已审核的话就没办法修改了）
        getStudentNewData({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentNewData, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学期数
        getSemester({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getSemester, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //教学计划(两个都查这个)
        getTeachingPlanCourse({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getTeachingPlanCourse, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //选课中心 列表(全部)
        getElectiveCourse({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getElectiveCourse, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //选课中心 列表（已选）
        getSelectedElectiveCourse({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getSelectedElectiveCourse, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //选课中心 选课
        electiveCourse({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.electiveCourse, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //选课中心 退课
        delElectiveCourse({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.delElectiveCourse, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 列表
        getLeaningCenterList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getLeaningCenterList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 学习
        getLeaning({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getLeaning, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 学习 学习记录
        getLeaningLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getLeaningLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 学习 开始学习
        leaning({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.leaning, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 作业 列表
        getFaceSetting({commit}, tePlanCourseId) {
            commit('STARTREQUEST', null, {root: true});
            const params = {
                page: 1,
                limit: 1,
                courseId: tePlanCourseId
            }
            return new Promise((resolve, reject) => {
                postParams(APIDOC.USER.getFaceSetting, params)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getHomeworkList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getHomeworkList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 作业 开始作业
        getHomeworkInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getHomeworkInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 作业 答题
        answerHomework({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.answerHomework, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 作业 交卷
        handHomework({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.handHomework, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 作业记录
        getHomeworkLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getHomeworkLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 作业记录 查看答卷
        getHomeworkStudentInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getHomeworkStudentInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 作业记录 继续作业
        continueHomeworkInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.continueHomeworkInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 考试 列表
        getExamList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getExamList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 考试 开始考试
        getExamInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getExamInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 考试 答题
        answerExam({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.answerExam, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 考试 交卷
        handExam({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.handExam, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 考试 考试记录
        getExamLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getExamLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 考试记录 查看答卷
        getExamStudentInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getExamStudentInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 错题本 按作业模块练习（列表 传homeworkStudentId）
        wrongQuestionQuery({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.wrongQuestionQuery, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 错题本 练习、直接练习 (不传homeworkStudentId)
        wrongQuestionInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.wrongQuestionInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 错题本 删除
        deleteWrongQuestion({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.deleteWrongQuestion, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 答疑 列表
        getLeavingMessageQuery({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getLeavingMessageQuery, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 答疑 提问
        addLeavingMessage({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.addLeavingMessage, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 答疑 讨论（就是在答疑下面加话）
        tackedOnLeavingMessage({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.tackedOnLeavingMessage, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 答疑 删除 提问或讨论
        deleteLeavingMessage({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.deleteLeavingMessage, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 答疑 点赞（重复点就是取消）
        editLike({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.editLike, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学习中心 答疑 收藏（重复点就是取消）
        collection({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.collection, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //资料下载 列表
        getCourseResourceList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getCourseResourceList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //资料下载 列表 点击下载后的反馈
        downloadFeedback({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.downloadFeedback, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 个人信息 查看
        getPersonalInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getPersonalInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 个人信息 修改
        editPersonalInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.editPersonalInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 学籍照片查询 审核通过的就不能修改了
        getStudentStatusPhoto({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentStatusPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, ////学生信息 学籍照片上传
        addStudentStatusPhoto({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.addStudentStatusPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 毕业照片查询 审核通过的就不能修改了
        getStudentGraduationPhoto({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentGraduationPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 毕业照片上传
        addStudentGraduationPhoto({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.addStudentGraduationPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 我的消息 列表
        getMyMessageList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getMyMessageList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 我的消息 一键已读
        setAllAcceptState({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.setAllAcceptState, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 我的消息 查看详情
        getMyMessageInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getMyMessageInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 修改密码
        editPassword({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.editPassword, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //通知公告 列表
        getNoticeList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getNoticeList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //通知公告 详情
        getNoticeInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getNoticeInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //获取未读通知
        getMyMessageNum({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getMyMessageNum, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 学籍照片确认
        confirmStudentStatusPhoto({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.confirmStudentStatusPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生信息 毕业照片确认
        confirmStudentGraduationPhoto({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.confirmStudentGraduationPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //提交视频记录
        acceptData({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.acceptData, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //获取视频分段
        getM3U8List({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getM3U8List, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //保存视频记录信息
        saveVideosLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.saveVideosLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //新的保存视频记录信息
        newSaveVideosLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.newSaveVideosLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //成绩查询
        getGrades({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getGrades, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },//动态表头
        getAchievementItemTableHeader({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getAchievementItemTableHeader, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },//动态表头
        getMakeUpExamList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getMakeUpExamList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //获取新生信息
        getStudentNewInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentNewInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //学生报道 1:已报到，2:未确认
        confirmStudentNewInfo({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.confirmStudentNewInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //获取学生录取通知书信息
        useImgTemplate({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.useImgTemplate, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //获取学生表格模板
        useTableTemplate({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.useTableTemplate, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //下载学籍卡
        exportTableTemplateToPdf({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.exportTableTemplateToPdf, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        }, //补考列表
        queryMakeUpExam({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.queryMakeUpExam, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getMakeUpExamLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getMakeUpExamLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        saveCompensateVideosLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.saveCompensateVideosLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getClientNeedStudyLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getClientNeedStudyLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        compensateVideoLog({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.compensateVideoLog, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        face({commit}, payload) { //人脸识别
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.face, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        face_record({commit}, payload) { //人脸识别
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postParams(APIDOC.USER.face_record, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getDissertation({commit}, payload) { //获取论文信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getDissertation, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        updateDissertationUrl({commit}, payload) { //保存论文
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.updateDissertationUrl, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getMessageAccept({commit}, payload) { //获取最新消息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getMessageAccept, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getCanEditTemplateSingle({commit}, payload) { //获取可编辑模板
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getCanEditTemplateSingle, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getEditStatusChangeTemplate({commit}, payload) { //获取可编辑模板
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getEditStatusChangeTemplate, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        saveEditTemplateData({commit}, payload) { //保存模板信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.USER.saveEditTemplateData, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getAttrTreeById({commit}, payload) { //根据模板ID获取树结构值
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getAttrTreeById, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getTemplateByName({commit}, payload) { //获取模板信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getTemplateByName, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getTemplateById({commit}, payload) { //获取模板信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getTemplateById, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getLivePlanList({commit}, payload) { //获取模板信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getLivePlanList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        saveLiveWork({commit}, payload) { //保存作业url提交
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.saveLiveWork, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        updateLiveWork({commit}, payload) { //编辑作业url提交
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.updateLiveWork, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getSurveyList({commit}, payload) { //问卷列表
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getSurveyList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getSurveyMessageNum({commit}, payload) { //未填写的问卷数量
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getSurveyMessageNum, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getTeacherEvaluateList({commit}, payload) { //教师评价列表
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getTeacherEvaluateList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getTeacherEvaluate({commit}, payload) { //获取教师评价信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getTeacherEvaluate, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        saveTeacherEvaluate({commit}, payload) { //保存教师评价
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.USER.saveTeacherEvaluate, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getTeaEvaluateMessageNum({commit}, payload) { //未填写的教师评价数量
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getTeaEvaluateMessageNum, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getElectivesList({commit}, payload) { //选课中心 选修课列表【新】
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getElectivesList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        joinElective({commit}, payload) { //选课中心 加入选修课【新】
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.joinElective, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStuNewVerifyPhoneOpenConfig({commit}, payload) { //是否开启手机验证
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStuNewVerifyPhoneOpenConfig, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentVerifyData({commit}, payload) { //获取学生手机号校验数据
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentVerifyData, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getVerifyStudentPhoneNeedSendSms({commit}, payload) { //是否需要填写验证码才能确定
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getVerifyStudentPhoneNeedSendSms, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getVerifyCodeIntervalTime({commit}, payload) { //获取短信验证码发送冷却时间
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getVerifyCodeIntervalTime, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        sendVerifyCode({commit}, payload) { //发送验证码
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.sendVerifyCode, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        verifyStudentPhone({commit}, payload) { //校验手机验证码
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.verifyStudentPhone, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentReportShowConfig({commit}, payload) { //新生报到菜单是否显示
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentReportShowConfig, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentReportFlowConfig({commit}, payload) { //获取新生报道各个流程的开关配置
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentReportFlowConfig, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentPayStatus({commit}, payload) { //获取缴费状态
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentPayStatus, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getPayAmount({commit}, payload) { //显示缴费金额
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getPayAmount, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentNewPhoto({commit}, payload) { //获取学籍照片信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentNewPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        addStudentNewPhoto({commit}, payload) { //获取学籍照片保存信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.addStudentNewPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        confirmStudentNewPhoto({commit}, payload) { //学籍照片确认无误
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.confirmStudentNewPhoto, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentNewFaceInfo({commit}, payload) { //获取新生人脸识别状态，识别过了返回1，没有则返回0
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentNewFaceInfo, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        studentNewFace({commit}, payload) { //人脸识别，传一个image的base64
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.studentNewFace, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentNewDataNew({commit}, payload) { //获取报道材料字段以及确认状态，填写情况
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentNewDataNew, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        saveStudentNewData({commit}, payload) { //保存报道材料
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.USER.saveStudentNewData, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getIdentityDocumentExplain({commit}, payload) { //获取身份证明说明
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getIdentityDocumentExplain, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentNewProof({commit}, payload) { //获取身份证明文件列表
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentNewProof, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        saveStudentNewProof({commit}, payload) { //保存身份证明
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.USER.saveStudentNewProof, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getLiveDetectSessionId({commit}, payload) { //获取活体检测会话ID和动作代码
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getLiveDetectSessionId, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        liveDetect({commit}, payload) { //提交活体检测视频
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postFormData(APIDOC.USER.liveDetect, payload.formData, payload.option)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        uploadIdentityDocument({commit}, payload) { //上传身份证明
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.uploadIdentityDocument, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        confirmStudentNewData({commit}, payload) { //确认报到材料无误
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.confirmStudentNewData, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getRegistrationTime({commit}, payload) { //获取报到时间范围
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getRegistrationTime, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        confirmReport({commit}, payload) { //确认报到
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.confirmReport, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getReportStatus({commit}, payload) { //获取报道状态
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getReportStatus, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getRegistrationMaterialsOpenConfig({commit}, payload) { //获取报道材料菜单是否开启
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getRegistrationMaterialsOpenConfig, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getMyFinanceOpenConfig({commit}, payload) { //获取我的财务菜单是否开启
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getMyFinanceOpenConfig, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getElectiveRequire({commit}, payload) { //是否完成选课
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getElectiveRequire, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentVideoInfo({commit}, payload) { //查询课程的已学进度
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getStudentVideoInfo, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentMenuList({commit}, payload) { //获取菜单信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentMenuList, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        listShowTemplate({commit}, payload) { //获取模版菜单
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.listShowTemplate, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getTeachingPlanCourseResourceList({commit}, payload) { //根据教学计划获取资源信息list
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getTeachingPlanCourseResourceList, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getElectronicTextbooksList({commit}, payload) { //根据教学计划获取电子教材list
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getElectronicTextbooksList, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getSuperintendentData({commit}, payload) { //获取学生端督学提示 首页调用 隔一天调用一次
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getSuperintendentData, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getOpenProgressBar({commit}, payload) { //配置是否要开启进度条 第一遍播放没有进度条，完整看完后展示进度条
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getOpenProgressBar, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getSuperintendentPromptTime({commit}, payload) { //配置督学提示间隔时长 单位为毫秒
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getSuperintendentPromptTime, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getVideoCreateInfo({commit}, payload) { //根据慕课视频id获取视频播放信息创建播放器
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getVideoCreateInfo, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        creatQRCode({commit}, payload) { //生成签名二维码
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.creatQRCode, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getAttributeRelation({commit}, payload) { //查询某个值的填写状态
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getAttributeRelation, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentChangeRecordList({commit}, payload) { //查询学籍异动申请记录
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentChangeRecordList, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        applyStatusChange({commit}, payload) { //申请学习异动
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.USER.applyStatusChange, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStatusChangeInfo({commit}, payload) { //获取异动说明
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStatusChangeInfo, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getSchoolClassValues({commit}, payload) { //班级列表
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getSchoolClassValues, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getProfessionalValues({commit}, payload) { //专业列表
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getProfessionalValues, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getCorrespondenceSchoolValues({commit}, payload) { //函授站列表
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getCorrespondenceSchoolValues, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        isShowStatusChange({commit}, payload) { //是否显示自主异动学籍功能
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.isShowStatusChange, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentStatusPayInfo({commit}, payload) { //查询在籍生是否缴费
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentStatusPayInfo, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        creatStudentStatusOrder({commit}, payload) { //查询在籍生是否缴费
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.creatStudentStatusOrder, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getWeChatPayQRCode({commit}, payload) { //在籍：生成微信支付二维码
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.getWeChatPayQRCode, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getStudentQQGroupInfo({commit}, payload) { //根据correspondenceSchoolId获取QQ群信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getStudentQQGroupInfo, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getPayQRCode2Student({commit}, payload) { //获取缴费二维码
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getPayQRCode2Student, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getFanYuAuthUrl({commit}, payload) { //获取维普跳转地址
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getFanYuAuthUrl, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getDegreeApplyConfig({commit}, payload) { //获取学生对于是否显示学位申请的配置信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getDegreeApplyConfig, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        addDegreeApplyConfig({commit}, payload) { //记录这次选择
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                post(APIDOC.USER.addDegreeApplyConfig, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getLatestDegreeApplyRecord({commit}, payload) { //获取学生最新的申请记录
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getLatestDegreeApplyRecord, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        submitDegreeApplyRecord({commit}, payload) { //提交新申请记录接口
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.USER.submitDegreeApplyRecord, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getDegreeApplyTemplate({commit}, payload) { //获取学位模板信息，包含html和属性列表
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.getDegreeApplyTemplate, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        degreeApplyForLanguageOption({commit}, payload) { //获取外语水平认定形式下拉框
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                get(APIDOC.USER.degreeApplyForLanguageOption, payload).then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/user.js